<template>
  <div id="organ" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_organ"></div>
    <div class="container">
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div class="organ mess" style="margin: 50px 0 0 0;">
            <el-link :underline="false">公司机构</el-link>
            <!-- <p style="font-size: 22px !important; font-weight: bolder;">COMPANY ORGANIZATION</p> -->
          </div>
        </el-col>
      </el-row>
      <el-divider class="space"></el-divider>
      <p class="organmess">
        河北国超信息科技有限公司组建1家合资公司、5家子公司、1家分公司、6个办事处及1所职业培训学校。公司内设七个部门：数据资料开发部、软件技术开发部、印前设计部、图形处理部、翻译管理部、综合事业部、财务管理部，分别在长春、重庆、天津、北京、杭州、上海分别设有业务办事处。
      </p>
      <el-divider style="margin-bottom: 20px;"><i class="el-icon-menu" style="font-size: 22px;"><span style="margin-left: 15px;">公司组织机构拓扑图</span></i></el-divider>
      <div class="organ-show" style="text-align: center;">
        <!-- <div ref="tree" style="height: 1500px;"></div> -->
        <div id="view_content"></div>
        <!--  <img style="margin: 30px 0;" src="../assets/img/jigoutu.png" /> -->
      </div>
      <div class="organ-hidden">
        <div id="topology">
          <v-topo :editable="true" :topo-data="nodes">
          </v-topo>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  import {
    DataSet,
    Network
  } from 'vis'
  export default {
    name: 'organ',
    components: {
      navheader,
      fixheader,
      filing,
      // OrgChart
    },
    data() {
      return {
        nodes: [],
      }
    },
    mounted() {
      this.init();
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
    },
    methods: {
      init() {
        // // create an array with nodes
        let nodes = new DataSet([{
            id: 1,
            label: '河北国超信息科技有限公司'
          },
          {
            id: 2,
            label: '7个部门'
          },
          {
            id: 3,
            label: '6个办事处'
          },
          {
            id: 25,
            label: '5家子公司'
          },
          {
            id: 4,
            label: '培训学校'
          },
          {
            id: 5,
            label: '合资公司（中日）'
          },
          {
            id: 7,
            label: '数据资料开发部',
            type: 5
          },
          {
            id: 8,
            label: '软件技术开发部',
            type: 3
          },
          {
            id: 9,
            label: '印前设计部',
            type: 1
          },
          {
            id: 10,
            label: '图形处理部',
            type: 2
          },
          {
            id: 11,
            label: '翻译管理部',
            type: 4
          }, {
            id: 12,
            label: '综合事业部'
          }, {
            id: 13,
            label: '财务管理部'
          },
          {
            id: 14,
            label: '长春办事处'
          }, {
            id: 15,
            label: '重庆办事处'
          }, {
            id: 16,
            label: '天津办事处'
          }, {
            id: 17,
            label: '北京办事处'
          }, {
            id: 18,
            label: '杭州办事处'
          }, {
            id: 19,
            label: '上海办事处'
          },

          {
            id: 20,
            label: '国超职业培训学校'
          },

          {
            id: 23,
            label: '广州国超森茂森信息技术有限公司'
          },
          {
            id: 24,
            label: '北京分公司'
          },


          {
            id: 26,
            label: '辛集市国超劳务派遣有限公司'
          },


          {
            id: 27,
            label: '河北国超数字科技有限公司'
          },


          {
            id: 28,
            label: '河北国超热力工程有限公司'
          },


          {
            id: 29,
            label: '河北国超消防设备科技有限公司'
          },
          {
            id: 30,
            label: '天津国超软件技术有限公司'
          },
          {
            id: 31,
            label: '分公司'
          },
          {
            id: 32,
            label: '芜湖分公司'
          }
        ])
        // // create an array with edges
        var edges = new DataSet([{
            from: 1,
            to: 2
          },
          {
            from: 1,
            to: 3
          },
          {
            from: 1,
            to: 25
          },
          {
            from: 1,
            to: 31
          },
          {
            from: 1,
            to: 4
          },
          {
            from: 1,
            to: 5
          },
          {
            from: 1,
            to: 6
          },
          {
            from: 2,
            to: 7
          },
          {
            from: 2,
            to: 8
          },
          {
            from: 2,
            to: 9
          },
          {
            from: 2,
            to: 10
          },
          {
            from: 2,
            to: 11
          },
          {
            from: 2,
            to: 12
          },
          {
            from: 2,
            to: 13
          },
          {
            from: 3,
            to: 14
          },
          {
            from: 3,
            to: 15
          },
          {
            from: 3,
            to: 16
          },
          {
            from: 3,
            to: 17
          },
          {
            from: 3,
            to: 17
          },
          {
            from: 3,
            to: 18
          },
          {
            from: 3,
            to: 19
          },
          {
            from: 4,
            to: 20
          },
          {
            from: 4,
            to: 21
          },
          {
            from: 4,
            to: 22
          },
          {
            from: 5,
            to: 23
          },
          {
            from: 23,
            to: 24
          },

          {
            from: 6,
            to: 25
          },
          {
            from: 6,
            to: 26
          },
          {
            from: 6,
            to: 27
          },
          {
            from: 6,
            to: 28
          },
          {
            from: 6,
            to: 29
          },
          {
            from: 25,
            to: 26
          },
          {
            from: 25,
            to: 27
          },
          {
            from: 25,
            to: 28
          },
          {
            from: 25,
            to: 29
          },
          {
            from: 25,
            to: 30
          },
          {
            from: 31,
            to: 32
          }
        ])
        // create a network
        var container = document.querySelector('#view_content')
        // provide the data in the vis format
        var data = {
          nodes: nodes,
          edges: edges,
        }
        var options = {
          //节点样式
          nodes: {
            shape: 'box', //设置节点node样式为矩形
            fixed: false, //节点node固定可移动
            font: {
              color: '#fff', //字体的颜色
              size: 46, //显示字体大小
            },
            scaling: {
              min: 16,
              max: 32, //缩放效果比例
            },
          },
          //连接线的样式
          edges: {
            color: {
              color: 'rgb(97, 168, 224)',
              highlight: 'rgb(97, 168, 224)',
              hover: 'green',
              inherit: 'from',
              opacity: 1.0,
            },
            font: {
              align: 'bottom', //连接线文字位置
            },
            smooth: true, //是否显示方向箭头
            arrows: {
              to: true
            }, //箭头指向from节点
            // physics:false
          },
          layout: {
            //以分层方式定位节点
            hierarchical: {
              direction: 'LR', //分层排序方向
              sortMethod: 'directed', //分层排序方法
              levelSeparation: 600, //不同级别之间的距离
              blockShifting: false
            },
          },
          interaction: {
            navigationButtons: true,
            // hover: true, //鼠标移过后加粗该节点和连接线
            selectConnectedEdges: false, //选择节点后是否显示连接线
          },
        }
        // initialize your network!
        this.network = new Network(container, data, options)
        this.network.on('click', (data) => {
          if (nodes._data[data.nodes[0]].type) {
            this.$router.push({
              path: '/dep',
              query: {
                type: nodes._data[data.nodes[0]].type,
              }
            })
          }

        }) //单击事件
        // this.network.on('doubleClick', (e) => this.enterService(e)) //双击事件
        //生成图后才生成canvas元素，此处设置画布大小
        // let element = document.getElementsByTagName('canvas')[0]
        // element.height = '600'
      },
    },
  }
</script>

<style>
  #view_content {
    width: 100%;
    height: 1200px;
  }

  .vis-network {
    height: 600px;
  }

  #organ .organ .el-row .el-col .el-card {
    height: auto;
    min-height: auto;
    max-width: auto;
  }

  #organ .edit-wrapper .edit-fields>div>div,
  #organ .edit-wrapper .edit-fields div:nth-child(2),
  #organ .edit-wrapper .edit-fields div:nth-child(3) {
    display: none;
  }

  #organ .edit-wrapper .edit-fields>div>hr {
    border: 0 !important;
  }

  #organ .edit-wrapper .edit-fields>div>input {
    color: rgba(0, 0, 0, 0.8) !important;
  }

  #organ .edit-wrapper .edit-fields>.edit-tags>span {
    color: rgba(0, 0, 0, 0.8) !important;
    background-color: transparent !important;
    text-indent: 2em;
    border: 0 !important;
    line-height: 26px;
  }

  #organ .edit-wrapper .edit-photo>img {
    width: 80px !important;
    height: auto !important;
    border-radius: 0 !important;
  }

  #organ image {
    height: 40px !important;
    width: auto !important;
  }

  #organ g.node text {
    width: 160px !important;
    font-size: 14px !important;
    text-overflow: clip !important;
  }

  #organ g.node rect:nth-child(2) {
    width: 160px !important;
    x: 10px;
  }

  #organ .organmess {
    text-indent: 2em;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.7);
    margin: 30px 0 80px 0;
  }

  #organ div.space {
    height: 3px !important;
    position: relative;
    margin-bottom: 80px;
  }

  #organ div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #organ .organ-show {
    display: block;
  }

  #organ .organ-hidden {
    display: none;
  }

  #organ .organ-hidden img {
    width: 100%;
    height: auto;
    margin: 20px 0;
  }

  @media (max-width:800px) {
    #organ .organ-show {
      display: none !important;
    }

    #organ .organ-hidden {
      display: block !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_organ.vue